<template>
    <div>
        <div class="w-g-information ">
            <h2></h2>
            <div id="applyBox">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="230px" class="demo-ruleForm">
                  <el-form-item label="请选择服务器(区):" prop="service" style="display: inline-block">
                      <el-select v-model="ruleForm['service']" style="width:320px"  v-if='tid == 5 || tid == 69'>
                          <el-option label="VIP1区" value="38"></el-option>
                      </el-select>
                      <el-select v-model="ruleForm['service']" style="width:320px"  v-else>
                          <el-option v-for='item in gameData' :label="item.info" :value="item.id" :key="item.id"></el-option>
                      </el-select>
                  </el-form-item>
				  <el-form-item label="请选择角色:" prop="role" style="display: inline-block">
				      <el-select v-model="ruleForm['role']"  style="width:320px">
				          <el-option v-for='item in nameData' :label="item" :value="item" :key="item"></el-option>
				      </el-select>
				  </el-form-item>
                  <!-- <el-form-item label="角色名" prop="role"  class="fixwidth"  >
                         <el-input  type="text" v-model="ruleForm['role']"  placeholder="请输入角色名" class="width"  ></el-input>
                  </el-form-item> -->
				  <el-dialog v-for="data in sub" :append-to-body="true"
				    :visible.sync="dialogVisible"
            :key="data.num"
				    width="30%">
				    <span slot="title" class="dialog-footer">{{data.msg}}</span>
				    <span >流水号为：{{data.num}}</span>
				    <span slot="footer" class="dialog-footer">
				    <el-button type="primary" @click="an()">确定</el-button>
				    </span>
					</el-dialog>
                  <div v-for="(item ,index) in list_data" style="position: relative">
                        <el-form-item :label="item.Introduction" :prop="item.Name"  class="fixwidth"  >
                            <FontOnlyUpload v-model="ruleForm[item.Name]" :cl=cl @input="checkall(item.Name)()"  class="width"  v-if="item.Type=='img'" ></FontOnlyUpload>
                            <el-input  type="text" v-model="ruleForm[item.Name]"  :placeholder="item.Tip" class="width"   v-if="item.Type=='card'"></el-input>
                            <el-input  type="text" v-model="ruleForm[item.Name]"  :placeholder="item.Tip" class="width"  v-if="item.Type=='text'"></el-input>
                            <el-input  type="text" v-model="ruleForm[item.Name]"  :placeholder="item.Tip" class="width"  v-if="item.Type=='email'"></el-input>
                            <el-input  type="text" v-model="ruleForm[item.Name]"  :placeholder="item.Tip" class="width"  v-if="item.Type=='tel'"></el-input>
                            <el-input  type="textarea" v-model="ruleForm[item.Name]"  :placeholder="item.Tip" class="width"  rows="6"  v-if="item.Type=='textarea'"></el-input>
                            <el-input  type="password" v-model="ruleForm[item.Name]"  :placeholder="item.Tip" class="width"   v-if="item.Type=='password'"></el-input>
                            <FontUpload  type="textarea" v-model="ruleForm[item.Name]" :cl=cl @input="checkall(item.Name)()"  :placeholder="item.Tip" class="width"   v-if="item.Type=='cardimg'"></FontUpload>
                            <el-radio-group  v-model="ruleForm[item.Name]"  v-if="item.Type=='radio'" >
                              <el-radio label="是">是</el-radio>
                              <el-radio label="否">否</el-radio>
                            </el-radio-group>

                            <el-date-picker
                                    v-model="ruleForm[item.Name]"
                                    type="datetime"
                                    placeholder="选择日期时间"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    v-if="item.Type=='date'"
                            >
                            </el-date-picker>
                            <el-date-picker
                                    v-if="item.Type=='time'"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    v-model="ruleForm[item.Name]"
                                    placeholder="选择日期时间">
                            </el-date-picker>
                          <div class="rediotip" v-if="item.Tip">{{item.Tip}}</div>
                        </el-form-item>
                  </div>
              </el-form>
              <div class="biaogea">
                <div class="submitBtnPanel  anniua" style="margin-top:20px;padding-bottom:60px;cursor:pointer">
                    <a @click.prevent='submitForm'>
                        确定
                    </a>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script >
    /**
     * 每一项表单渲染
     *
     */
    let getIdCardInfo = function getIdCardInfo(cardNo) {
        try {
        var info = {
            isTrue: false, // 身份证号是否有效。默认为 false
            year: null, // 出生年。默认为null
            month: null, // 出生月。默认为null
            day: null, // 出生日。默认为null
            isMale: false, // 是否为男性。默认false
            isFemale: false // 是否为女性。默认false
        };
        if (!cardNo && 15 != cardNo.length && 18 != cardNo.length) {
            info.isTrue = false;
            return info;
        }
        if (15 == cardNo.length) {
            var year = cardNo.substring(6, 8);
            var month = cardNo.substring(8, 10);
            var day = cardNo.substring(10, 12);
            var p = cardNo.substring(14, 15); // 性别位
            var birthday = new Date(year, parseFloat(month) - 1, parseFloat(day));
            // 对于老身份证中的年龄则不需考虑千年虫问题而使用getYear()方法
            // @ts-ignore
            if (birthday.getYear() != parseFloat(year) || birthday.getMonth() != parseFloat(month) - 1 || birthday.getDate() != parseFloat(day)) {
                info.isTrue = false;
            } else {
                // @ts-ignore
                info.isTrue = true;
                // @ts-ignore
                info.year = birthday.getFullYear();
                // @ts-ignore
                info.month = birthday.getMonth() + 1;
                // @ts-ignore
                info.day = birthday.getDate();
                if (p % 2 == 0) {
                    info.isFemale = true;
                    info.isMale = false;
                } else {
                    info.isFemale = false;
                    info.isMale = true;
                }
            }
            return info;
        }
        if (18 == cardNo.length) {
            var year = cardNo.substring(6, 10);
            var month = cardNo.substring(10, 12);
            var day = cardNo.substring(12, 14);
            var p = cardNo.substring(14, 17);
            var birthday = new Date(year, parseFloat(month) - 1, parseFloat(day));
            // 这里用getFullYear()获取年份，避免千年虫问题
            if (birthday.getFullYear() != parseFloat(year) || birthday.getMonth() != parseFloat(month) - 1 || birthday.getDate() != parseFloat(day)) {
                info.isTrue = false;
                return info;
            }
            var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
            var Y = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值.10代表X
            // 验证校验位
            var sum = 0; // 声明加权求和变量
            var _cardNo = cardNo.split("");
            if (_cardNo[17].toLowerCase() == 'x') {
                _cardNo[17] = 10; // 将最后位为x的验证码替换为10方便后续操作
            }
            for (var i = 0; i < 17; i++) {
                sum += Wi[i] * _cardNo[i]; // 加权求和
            }
            var i = sum % 11; // 得到验证码所位置
            if (_cardNo[17] != Y[i]) {
                return info.isTrue = false;
            }
            info.isTrue = true;
            // @ts-ignore
            info.year = birthday.getFullYear();
            // @ts-ignore
            info.month = birthday.getMonth() + 1;
            // @ts-ignore
            info.day = birthday.getDate();
            if (p % 2 == 0) {
                info.isFemale = true;
                info.isMale = false;
            } else {
                info.isFemale = false;
                info.isMale = true;
            }
            return info;
        }
        return info;
        }catch (e) {
            return {isTrue:false}
        }
    };
  import FontUpload from "./Font-upload.vue";
  import FontOnlyUpload from "./Font-onlyuoload.vue";
  export default {
    name: "form_item",
    components: {
      FontUpload,
      FontOnlyUpload
    },
    data(){
      return {
        flag:false,
        dialogVisible:false,
        sub:[],
		nameData:[],
		show:true,
		cl:false,
        ruleForm:{
          tid: '',
          game_id:'',
          iskefu: 0,
          cast: '',
          role: '',
          service:"",
        },
      }
    },
    props:['list_data','gameData','tid','gameid','cast'],
	watch: {
		'ruleForm.service':function(newValue, oldValue) {
			if(oldValue!==newValue){
				var gData=this.gameData
				//console.log(111)
				for(var i=0;i<gData.length;i++){
					if(gData[i].id==newValue){
						this.ruleForm.role=''
						this.getName(gData[i].serverid)
					}
				}
			}
	    }
	},
    methods:{
      init(){
        this.$refs['ruleForm'].clearValidate()
      },
	  getName(id){
		this.$axios({
		  method: 'get',
		  url: '/index.php/user/user/get_role',
		  params: {
			id:id
		  }
		}).then(res => {
		//console.log(res.data)
		  if(res.data.status==200){
			this.nameData=res.data.data
		  }
		})
	  },
      uploadcheck(rule, value, callback){
        if(value=='视频验证'){
          callback();
          return;
        }
        if(!value){
          callback(new Error(rule.message));
          return
        }
        try {
          value=JSON.parse(value)
        }catch (e) {
          callback(new Error(rule.message));
        }
        if(value&&value.length>0){
          callback();
          return;
        }else{
          callback(new Error(rule.message));
          return;
        }
      },
      cardcheck(rule, value, callback){
        //  console.log(value)
        // @ts-ignore
        if(getIdCardInfo(value).isTrue){
          if(this.tid==7||this.tid==19||this.tid==69){
            var name=this.ruleForm['zhenshixingming']
            if(name){
              this.$axios({
                method: 'get',
                url: '/index.php/user/User/yzname',
                params: {
                  zhenshixingming:name,
                  xinshenfenzhenghaoma:value
                }
              }).then(res => {
                if(res.data.status==200){
                  name=''
                  callback();
                  return;
                }else if(res.data.status==500){
                  this.$alert(res.data.data, {
                  	confirmButtonText: '确定',
                  });
                  name=''
                }
              })
            }
          }else{
            callback();
            return;
          }
        }else{
          callback(new Error(rule.message));
          return;
        }
      },
      checkall(filed){
        return (data)=>{
          //this[filed]=data;
          // @ts-ignore
          this.$refs['ruleForm'].validateField(filed,(valid)=>{
          })
        }
      },
	  an(){
		this.sub=[]
		this.dialogVisible=false
	  },
      submitForm() {
        // @ts-ignore
        this.$refs['ruleForm'].validate((valid)=>{
          if(valid){
			//console.log(this.tid)
			//this.ruleForm['service']=this.serverid
			this.ruleForm['tid']=this.tid
			this.ruleForm['cast']=this.cast
			this.ruleForm['game_id']=this.gameid
			//console.log(this.ruleForm)
			this.$axios({
			  method: 'post',
			  url: '/index.php/user/User/submit',
			  data : this.ruleForm
			}).then(res => {
			  if(res.data.status==200){
				this.sub.push(res.data)
				if(this.tid==13||this.tid==30){
					this.sub[0].msg='提交成功！客服需核对申请者所提供资料的准确性，请您在问题提交后的24小时内关注该申请是否已受理！</br>被盗问题初步处理时间为5天，请在问题提交后的第6天登录自助系统关注物品追回或是置换情况。'
				}else if(this.tid==69){
          this.sub[0].msg='我们将为您在5个工作日内审核相关信息，请您近期登录系统查看处理进度。'
        }else{
					this.sub[0].msg='我们将为您在24小时内审核相关信息，请您近期登录系统查看处理进度。'
				}
				this.dialogVisible=true
				this.cl=true
				this.ruleForm={tid:'',game_id:'',iskefu: 0,cast:'',role: '',service:'',}
			  }else if(res.data.status==500){
				this.$message({
					type: 'error',
					message:res.data.data,
					offset:300
				});
			  }
			})
          }
        })
      },
      validPhone(rule, value, callback){
        if (!value){
          callback(new Error('请输入电话号码'))
        }else  if (! /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(value)){
          callback(new Error('请输入正确的11位手机号码'))
        }else {
          callback()
        }
      }
    },
    computed:{
        rules(){
          if(this.back==true){
            return  {};
          }
          let obj={
            'role':[ { required: true, message: '请选择角色名', trigger: 'change' }],
            'service':[ { required: true, message: '请选择区服', trigger: 'change' }]
          }
          let self=this;
          this.list_data.forEach((item  )=>{
            obj[item.Name]=obj[item.Name]||[];
            // @ts-ignore
            // self.ruleForm[item.Name]='';
            //  if(item.Type=="radio"){
            //      // @ts-ignore
            //      self.ruleForm[item.Name]='是';
            //  }
            if(item.Need=="true"){
              if(item.Type=="img"){
                obj[item.Name].push( {  validator: self.uploadcheck, message: '请提交图片信息', trigger: 'change' })
              }
              if(item.Type=="cardimg"){
                obj[item.Name].push( {  validator: self.uploadcheck, message: '请提交图片信息', trigger: 'change' })
              }
              if(item.Type=="tel"){
                obj[item.Name].push(  { validator: self.validPhone, message: '请输入正确'+item.Introduction, trigger: 'blur' },{ required: true,message: '请输入'+item.Introduction, trigger: 'blur' })
              }
              if(item.Type=="textarea"){
                obj[item.Name].push(  { required: true, message: '请输入'+item.Introduction, trigger: 'blur' },)
              }

              if(item.Type=="password"){
                obj[item.Name].push(  { required: true, message: '请输入'+item.Introduction, trigger: 'blur' },)
              }

              if(item.Type=="card"){
                obj[item.Name].push({  validator: self.cardcheck, message: '请输入正确的身份证', trigger: 'blur' }, { required: true, message: '请输入'+item.Introduction, trigger: 'blur' })
              }

              if(item.Type=="email"){
                obj[item.Name].push(    {type: 'email',   message: '请输入正确'+item.Introduction, trigger: 'blur' },{ required: true, message: '请输入'+item.Introduction, trigger: 'blur' },)
              }
              if(item.Type=="date"){
                obj[item.Name].push(   {  required: true, message: '请选择日期', trigger: 'change' })
              }
              if(item.Type=="time"){
                obj[item.Name].push(   {  required: true, message: '请选择日期', trigger: 'change' })
              }
              if(item.Type=="text"){
                obj[item.Name].push(  { required: true, message: '请输入'+item.Introduction, trigger: 'blur' },)
              }
              if(item.Type=="radio"){
                obj[item.Name].push( {  required: true, message: '请输入选择一项',  trigger: 'change' })
              }
            }else{
              if(item.Type=="tel"){
                obj[item.Name].push(  {validator:self.validPhone,    message: '请输入正确'+item.Introduction, trigger: 'blur' },)
              }
              if(item.Type=="email"){
                obj[item.Name].push(  {type: 'email',   message: '请输入正确'+item.Introduction, trigger: 'blur' })
              }
              if(item.Type=="card"){
                obj[item.Name].push(  {  validator: self.cardcheck, message: '请输入正确的身份证', trigger: 'blur' })
              }
              if(item.Type=="cardimg"){
                obj[item.Name].push( {  validator: self.uploadcheck, message: '请提交图片信息', trigger: 'change' })
              }
              if(item.Type=="radio"){
                obj[item.Name].push( {  required: true, message: '请输入选择一项',  trigger: 'change' })
              }
            }
          })
          return obj;
        }
    },
    created(){
		// if(this.gameid==5){
		// 	this.show=false
		// }
      this.ruleForm.game_id= this.gameid;
      this.ruleForm.tid= this.tid;
      this.ruleForm.cast= this.cast;
      if(this.tid=="5"){
        this.flag=true
        this.server_id="38"
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .fixwidth{display: inline-block;margin:25px 0}
    .width{width:320px}
    #applyBox textarea{width:350px!important;}
    .delAll{font-size:32px;position: absolute;right:20px;top:20px}
  .submitBtnPanel{color:#fff;}
  .rediotip{line-height:1.5;font-size:12px;margin:5px 20px 5px 0px;color:#c25205;width:350px}
</style>



// WEBPACK FOOTER //
// src/components/form_item.vue